(function () {
    'use strict';

    var PictureControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/picture.html',
        controllerAs: 'vm',
        bindings: {
            pages:'<',
            article:'<',
            product:'<',
            onAdd: '&'
        },
        controller: ['$scope', 'Folder', '$timeout', 'MessageService','Gallery','$uibModal','PlatformWechatSetting','StoreStorages','$stateParams','Customer','$localStorage','Article','CommonService','QiniuToken', '$websocket', '$q', '$translate',
            function ($scope, Folder, $timeout, MessageService,Gallery,$uibModal,PlatformWechatSetting,StoreStorages,
                $stateParams,Customer,$localStorage, Article,CommonService, QiniuToken, $websocket, $q, $translate) {
                var vm = this;
                vm.folderShow = false;
                vm.indexNum = 0;
                vm.itemsPerPage = 40;
                $scope.photos = [];
                vm.picLoading = false;
                vm.deleteSure = false;
                vm.folderIds = "";
                vm.folderId = "";
                vm.duplicateList = []; //重复图片
                vm.isDuplicateList = false//重复图片弹框
                vm.photosTab='all';
                vm.photoSort = '1';
                vm.totalPhotoItems = null;
                vm.maxId = null;
                vm.minId = null;
                $scope.gallaryPic = [];
                var newCreateDate = 0;
                vm.platformSetting = PlatformWechatSetting.get();
                vm.storeId = $stateParams.storeId;
                vm.customer = Customer.current();
                $scope.domain = localStorage.getItem('editor-domain');
                QiniuToken.get('get', {}, function (token) {
                    vm.token = token;
                });
                vm.$onInit = function() {
                    $q.all([vm.platformSetting.$promise, vm.customer.$promise]).then(function() {
                        loadFolders();
                        websocket();
                        loadAll('isNull');
                        $timeout(function() {
                            $('.page-photo-view2').on('scroll', function(event){
                                var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                                if($scope.photos.length < vm.totalPhotoItems){
                                    if((event.currentTarget.scrollHeight-10)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                                        vm.indexNum++;
                                        if(vm.folderId){
                                            loadAll(vm.folderId);
                                        } else {
                                            loadAll('isNull');
                                        }
                                    }
                                }
                            });
                        });
                    })
                    
                    // 监听 pages 对象的深层次值变化
                    $scope.$watch(function() {
                        return vm.pages;
                    }, function(newVal, oldVal) {
                        if (newVal !== oldVal && $scope.photos && $scope.photos.length > 0) {
                            // 当 pages 的深层次值发生变化时，重新计算照片使用数量
                            photosNum();
                        }
                    }, true); // 第三个参数 true 表示深度监听
                }
                
                function loadFolders() {
                    Folder.storeGetAllByCondition({
                        items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: vm.article.id}],
                        sort: ["id,asc"]
                    }, function (resp) {
                        if(resp.status == 200){
                            $scope.Folders = resp.data;
                        }else {
                            MessageService.error(resp.message);
                        }
                    })
                }
                $scope.folderOn = function () {
                    vm.folderShow = !vm.folderShow;
                };
                // 增加文件夹
                $scope.addFolder = function () {
                    $uibModal.open({
                        templateUrl: "app/entities/page/pagesmySuffix-create.html",
                        controller: "PageMySuffixCreateController",
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page)
                                };
                            }],
                            entity: [function() {
                                return {
                                    type: "NEW"
                                };
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('editorWeb');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function (backData) {
                        Folder.save({
                            name: backData,
                            type: 'Gallery',
                            articleId:vm.article.id
                        }, function (resp) {
                            $scope.Folders.push(resp.data);
                        })
                    });
                }
                //选择文件夹
                $scope.showFolderContent = function (folder) {
                    vm.indexNum = 0;
                    $scope.photos = [];
                    $scope.gallaryPic = [];
                    vm.folderId = folder ? folder.id : '';
                    vm.folderName = folder ? folder.name : '';
                    vm.totalPhotoItems = null;
                    vm.maxId = null;
                    vm.minId = null;
                    vm.unusedQuantity = null;
        
                    if (folder) {
                        loadAll(folder.id);
                    } else {
                        loadAll('isNull');
                    }
        
                };
                $scope.deleteShow = function (ids,event) {
                    fn(event)
                    vm.folderIds=ids;
                    MessageService.confirm({
                        title : $translate.instant("nav.photograph.content.folders.btn.cancelPop.title"),
                        cancel :$translate.instant("button.cancel"),
                        confirm :$translate.instant("button.confirm"),
                        msg :$translate.instant("nav.photograph.content.folders.btn.cancelPop.content")
                    }, function() {
                        Folder.batchDelete({ids: vm.folderIds}, function () {
                            vm.indexNum = 0;
                            vm.maxId = null;
                            vm.minId = null;
                            $scope.photos = [];
                            loadAll('isNull');
                            loadFolders();
                            MessageService.success($translate.instant("button.success"));
                        }, function () {
                            MessageService.error($translate.instant("button.error"));
                        });
                    })
                }
                $scope.updateFloders = function(folder,event){
                    event.stopPropagation();
                    $uibModal.open({
                        templateUrl: 'app/entities/page/pagesmySuffix-create.html',
                        controller: 'PageMySuffixCreateController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            entity: [function() {
                                return {
                                    type: "EDITOR",
                                    name: folder.name
                                };
                            }]
                        }
                    }).result.then(function (data) {
                        folder.name = data;
                        Folder.update(folder, function (resp) {
                            if(resp.status == 200){
                                loadFolders();
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.minId = null;
                                vm.totalPhotoItems = null;
                                $scope.photos = [];
                                loadAll('isNull');
                                MessageService.success($translate.instant("editorMessage.modifySuccess"));
                            }else {
                                MessageService.error(resp.message);
                            }
                        },function () {
                            MessageService.error($translate.instant("editorMessage.pleaseEnterTheCorrectFileName"));
                        })
                    }, function(){

                    });
                }
                $scope.photoSortChange = function (num) {
                    vm.indexNum = 0;
                    vm.photoSort = num;
                    vm.totalPhotoItems = null;
                    vm.maxId = null;
                    vm.minId = null;
                    $scope.photos = [];
                    if(vm.folderId){
                        loadAll(vm.folderId);
                    }else{
                        loadAll('isNull');
                    }
                }
                function loadAll(folderId) {
                    vm.picLoading = true;
                    var sort = ["id,desc"];
                    if(vm.photoSort == 1){
                        sort = ["id,desc"]
                    }else if(vm.photoSort == 2){
                        sort = ["name,desc"]
                    }else if(vm.photoSort == 3){
                        sort = ["name,asc"]
                    }
                    var items = [];
                    if (folderId == 'isNull') {
                        items.push({key: "folderId", op: "isNull", value: 1})
                    }else{
                        items.push({key: "folderId", op: "=",value: folderId});
                    }
                    if (vm.maxId) {
                        items.push({key: "id", op: "<=",value: vm.maxId});
                    }
                    if (vm.minId) {
                        items.push({key: "id", op: "<",value: vm.minId});
                    }
                    items.push({key: "articleId", op: "=", value: vm.article.articleId || vm.article.id})
                    if (folderId == 'isNull') {
                        $scope.selectFolder = $translate.instant("editorCommon.selectFolder");
                        Gallery.storeByCondition({
                            items: items,
                            page: vm.indexNum,
                            size: vm.itemsPerPage,
                            sort: sort
                        }, onSuccess, onError);
                    } else {
                        Gallery.storeByCondition({
                            items: items,
                            page: vm.indexNum,
                            size: vm.itemsPerPage,
                            sort: sort
                        }, onSuccess, onError);
                    }
                }
                function onSuccess(data, headers) {
                    if (vm.totalPhotoItems == null) {
                        vm.totalPhotoItems = Number(headers('X-Total-Count'));
                    }
                    if (data.data.length > 0 && vm.maxId == null && vm.photoSort == 1) {
                        vm.maxId = data.data[0].id;
                    }
                    vm.picLoading = false;
                    var len = $scope.photos.length;
                    angular.forEach(data.data, function (item, i) {
                        item.identifier = $scope.domain + item.identifier;
                        item.index = i + len;
                        item.usenum = 0;
                        item.type = 'picture';
                        if($scope.gallaryPic.some(function(item1){
                            item1.id === item.id
                        })){
                            item.select = true
                        }else{
                            item.select = false
                        }
                        $scope.photos.push(item);
                    });
                    if($scope.photos.length < vm.totalPhotoItems){
                        vm.isPhotoFinish = false;
                    }else {
                        vm.isPhotoFinish = true;
                    }
                    if ($scope.photos && $scope.photos.length>0) {
                        newCreateDate = new Date($scope.photos[0].createdDate).getTime();
                    }
                    photosNum();
                    $scope.whetherChoose(false);
                }
        
                function onError(error) {
                    vm.picLoading = false;
                    MessageService.error($translate.instant("editorMessage.failedToObtainThePhotoGallery"));
                }
                function photosNum(){
                    for(var i=0; i<$scope.photos.length; i++){
                        var _photo = $scope.photos[i];
                        _photo.usenum=0;
                        angular.forEach(vm.pages, function (data, index) {
                            if(Array.isArray(data)){
                                angular.forEach(data,function (page) {
                                    angular.forEach(page.levels.level, function (level, i) {
                                        if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                            if (level.imagebox.image.resourceid == _photo.id) {
                                                _photo.usenum++
                                            }
                                        }
                                    })
                                })
                            }else{
                                angular.forEach(data.levels.level, function (level, i) {
                                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                        if (level.imagebox.image.resourceid == _photo.id) {
                                            _photo.usenum++
                                        }
                                    }
                                })
                            }
                        })
                    }
                    unusedQuantity();
                }
                function unusedQuantity(){
                    var galleryIdList = [];
                    angular.forEach(vm.pages, function (data, i) {
                        if(Array.isArray(data)){
                            angular.forEach(data,function (page) {
                                angular.forEach(page.levels.level, function (level, i) {
                                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                        galleryIdList.push(level.imagebox.image.resourceid)
                                    }
                                })
                            })
                        }else{
                            angular.forEach(data.levels.level, function (level, i) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                    galleryIdList.push(level.imagebox.image.resourceid)
                                }
                            })
                        }
                    })
                    var newArr = galleryIdList.filter(function(item,index){
                        return galleryIdList.indexOf(item) === index;  // 因为indexOf 只能查找到第一个
                    });
                    Gallery.unUsed({
                        galleryIdList:newArr,
                        folderId: vm.folderId,
                        articleId: (vm.article.articleId || vm.article.id)
                    },function (res) {
                        if(res.status == 200){
                            vm.unusedQuantity = res.data;
                        }
                    })
                }
                $scope.switchBgTab = function (attr) {
                    vm.photosTab = attr;
                    if(vm.photosTab!='all'){
                        vm.unUsedImageboxsNum = 0;
                        angular.forEach($scope.photos,function (p) {
                            if(p.usenum==0){
                                vm.unUsedImageboxsNum++;
                            }
                        })
                    }else{
                        $scope.gallaryPic = [];
                        vm.indexNum = 0;
                        $scope.photos = [];
                        if (vm.folderId) {
                            loadAll(vm.folderId);
                        } else {
                            loadAll('isNull');
                        }
                    }
                }
                $scope.whetherChoose = function (attr) {
                    $scope.gallaryPic = [];
                    $scope.photos.some(function (p, i) {
                        if(vm.photosTab!='all'){
                            if(p.usenum==0||!p.usenum){
                                if (attr) {
                                    p.select = true;
                                    $scope.gallaryPic.push(p);      //选择导入图片的数组
                                } else {
                                    p.select = false;
                                    $scope.gallaryPic = [];      //选择导入图片的数组
                                }
                            }
                        }else{
                            if (attr) {
                                p.select = true;
                                $scope.gallaryPic.push(p);      //选择导入图片的数组
                            } else {
                                p.select = false;
                                $scope.gallaryPic = [];      //选择导入图片的数组
                            }
                        }
                    })
                }
                //手机传图
                vm.qrcodeShow = false;
                vm.fid = 0;
                var qrcode = null;
                var phonetimer = null;
                var newCreateDate = 0;
                $scope.uploadByPhone = function () {
                    uploadAble(StoreStorages,vm.storeId, function (res) {
                        if(res.status == 200){
                            vm.qrcodeShow = !vm.qrcodeShow;
                            if (qrcode != null) {
                                // qrcode.clear();
                                $('#qrcode1').html("");
                            }

                            //vm.folderId -----某一文件夹信息
                            if (vm.folderId == undefined || vm.folderId == null) {
                                vm.fid = 0;
                            } else {
                                vm.fid = vm.folderId;
                            }

                            Article.getPhonePicToken({id:(vm.article.articleId || vm.article.id)}, function(data){
                                // 手机传图二维码
                                qrcode = $('#qrcode1').qrcode({
                                    render: "canvas",
                                    width: 150,
                                    height: 150,
                                    text: '' + vm.platformSetting.data.editorNotifyUrl + "/#/" + vm.storeId + "/" + vm.fid + "/gallery/" + (vm.article.articleId || vm.article.id)+'?auth='+data.data
                                });
                            },function(){
                            })
                        }else{
                            if(res.status == 400){MessageService.error('系统出错');}
                            else {
                                MessageService.error(res.data||'系统出错');
                            }
                        }
                    })
                }
        
                $scope.uploadByPhone1 = function(){
                    vm.qrcodeShow = false;
                    clearInterval(phonetimer);
                    $scope.gallaryPic = [];
                    vm.indexNum = 0;
                    vm.maxId = null;
                    vm.minId = null;
                    $scope.photos = [];
                    if (vm.folderId) {
                        loadAll(vm.folderId);
                    } else {
                        loadAll('isNull');
                    }
                }

                
                //转移照片
                $scope.moveToFolder = function () {
                    if ($scope.gallaryPic.length < 1) {
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                        return
                    }
                    $uibModal.open({
                        templateUrl: 'app/entities/web-folder/entity-move-folder.html',
                        controller: 'EntityMoveFolderController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            entity: {
                                type: 'Gallery',
                                ids: $scope.gallaryPic.map(function(item){return item.id}),
                                folderId: vm.folderId,
                                articleId: (vm.article.articleId || vm.article.id)
                            },
                        }
                    }).result.then(
                        function() {
                            angular.forEach($scope.Folders, function (f, i) {
                                f.selected = false;
                            })
                            $scope.gallaryPic = [];
                            $scope.moveGalleryIds = [];
                            vm.unusedQuantity = null;
                            vm.oldQuantity = null;
                            vm.indexNum = 0;
                            vm.maxId = null;
                            vm.minId = null;
                            vm.totalPhotoItems = null;
                            $scope.photos = [];
                            vm.isMoveToFolder = false;
                            if (vm.folderId) {
                                loadAll(vm.folderId);
                            } else {
                                loadAll('isNull');
                            }
                        }
                    );
                }
                $scope.choosePhoto = function (photo) {
                    $scope.gallaryPic = [];
                    photo.select = !photo.select;
                    angular.forEach($scope.photos, function (p, i) {
                        if (p.select) {
                            $scope.gallaryPic.push(p);
                        }
                    });
                }
                $scope.directFill = function(){
                    if(!$scope.gallaryPic || $scope.gallaryPic.length === 0){
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                        return;
                    }
                    if(vm.onAdd){
                        vm.onAdd({
                            photos: $scope.gallaryPic
                        });
                    }
                }
                $scope.deleteBatchPhotos = function () {
                    if (!$scope.gallaryPic.length) {
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                        return
                    }
                    var _isExist = false;
                    angular.forEach(vm.pages, function (data, index) {
                        if(Array.isArray(data)){
                            angular.forEach(data,function (page) {
                                angular.forEach(page.levels.level, function (level, i) {
                                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                        if ($scope.gallaryPic.some(function(item){return item.id == level.imagebox.image.resourceid})) {
                                            _isExist = true
                                        }
                                    }
                                })
                            })
                        }else{
                            angular.forEach(data.levels.level, function (level, i) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                    if ($scope.gallaryPic.some(function(item){return item.id == level.imagebox.image.resourceid})) {
                                        _isExist = true
                                    }
                                }
                            })
                        }
                    })
                    if(_isExist){
                        MessageService.error($translate.instant("editorMessage.deleteBatchPhotosError"));
                        return
                    }
                    MessageService.confirm({
                        title :$translate.instant("button.prompt"),
                        cancel :$translate.instant("button.cancel"),
                        confirm :$translate.instant("button.delete"),
                        msg :$translate.instant("editorMessage.deleteBatchPhotosError1")
                    }, function(){
                        Gallery.batchDelete($scope.gallaryPic.map(function(item){return item.id}), function () {
                            MessageService.success($translate.instant("editorMessage.deleteSuccess"));
                            // 若被选中的pic被删除，就重新生成该数组
                            vm.unusedQuantity = null;
                            vm.maxId = null;
                            vm.minId = null;
                            vm.totalPhotoItems = null;
                            $scope.gallaryPic = [];
                            $scope.photos = [];
                            vm.indexNum = 0;
                            if(vm.folderId){
                                loadAll(vm.folderId);
                            } else {
                                loadAll('isNull');
                            }
                        }, function (error) {
                            MessageService.error($translate.instant("editorMessage.deleteError"));
                        });
                    })
                }
                vm.isWatchName = false;
                $scope.watchGalleryName = function(state){
                    vm.isWatchName = state;
                }

                
                $scope.uploadImage = function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    if (!vm.product.editTip || !vm.product.editTipPic || $localStorage.dotRemindEditorTipPic) {
                        $scope.uploadPic();
                        return
                    }
                    $uibModal.open({
                        templateUrl: 'app/entities/components/controls/editorTipPicModal.html',
                        controller: 'EditorTipPicModalController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    url: vm.product.editTipPic,
                                };
                            },
                        }
                    }).result.then(function() {
                        $scope.uploadPic();
                    });
                }
                $scope.uploadPic = function () {
                    uploadAble(StoreStorages,vm.storeId, function (res) {
                        if(res.status == 200){
                            $("#uploadImg2").trigger("click");
                        }else{
                            if(res.status == 400){MessageService.error('系统出错');}
                            else {
                                MessageService.error(res.data||'系统出错');
                            }
                        }
                    });
                }
                var bigSizePics = [];
                window.updatePic = function ($event) {
                    vm.duplicateList = []; //重置重复图片列表
                    vm.successNumber = 0;//上传成功数量
                    vm.errorNumber = 0;//上传失败数量
                    var oldlength = $event.target.files.length;
                    filterFiles($event.target.files).then(function(filterFilesList) {
                    var newlength = filterFilesList.length;
                    if (newlength < oldlength) {
                        MessageService.error($translate.instant("editorMessage.updatePicError"));
                    }
                    $timeout(function () {
                        vm.picLoading = true;
                        var len = $scope.photos.length;
                        var files = [];
                        var higherSize = [];
                        bigSizePics = [];
                        var uploadPromises = [];
                        // vm.totalPhotoItems = (vm.totalPhotoItems - 0) + (filterFilesList.length-0)
                        for (var i = 0; i < filterFilesList.length; i++) {
                            var f = filterFilesList[i];
                            f.imageSize = Math.ceil(f.size/1024/1024);
                            files.push(f)
                        }
                        if (files.length == 0) {
                            vm.picLoading = false;
                            return
                        }
                        for (var i = 0; i < files.length; i++) {
                            var file = files[i];
                            if (file.size>=50*1024*1024 || (file.width*file.height > 400000000)){
                                file.imageSize= Math.ceil(file.size/1024/1024);
                                bigSizePics.push(file);
                            }else{
                                uploadPromises.push(getBgImg(files, i, len));
                                if (bigSizePics.length==0 && i == (files.length-1)) {
                                    // vm.picLoading = false;
                                    setTimeout(function () {
                                        angular.forEach($scope.photos, function (item, j) {
                                            item.index = j;
                                        });
                                    }, 400)
                                }
                            }
                        }
                        // 等待所有上传完成后进行重复图片检测
                        Promise.all(uploadPromises).then(function() {
                            if(vm.duplicateList.length > 0){
                                MessageService.confirm({
                                    title :'提示',
                                    cancel :'取消',
                                    confirm :'确认',
                                    msg :'检测到图库中有'+vm.duplicateList.length+'张重复图片，是否需要自动去重？',
                                    html: '<span class="themecolor themecolor-btn">查看重复图片</span>'
                                }, function(res) {
                                    if(res == 'htmlClick'){
                                        vm.isDuplicateList = true;
                                    }else{
                                        var ids = [];
                                        vm.duplicateList.forEach(function (item){
                                            ids.push(item.id)
                                        })
                                        Gallery.batchDelete(ids, function () {
                                            MessageService.success("去重成功！");
                                            $scope.gallaryPic = [];
                                            vm.indexNum = 0;
                                            vm.totalPhotoItems = null;
                                            vm.maxId = null;
                                            vm.minId = null;
                                            $scope.photos = [];
                                            vm.duplicateList=[];
                                            if (vm.folderId) {
                                                loadAll(vm.folderId);
                                            } else {
                                                loadAll('isNull');
                                            }
                                        }, function (error) {
                                            MessageService.error("删除失败！");
                                            vm.duplicateList=[];
                                        });
                                    }
                                },function (){
                                    vm.duplicateList=[];
                                })
                            }
                            if (bigSizePics.length > 0) {
                                thumbnailatorPic();
                            }
                        });
                        $event.srcElement.value = "";
                    })
                    });
                };
                var uploadFailedList = []; //临时存储上传失败图片
                function getBgImg(files, i, len) {
                    return new Promise(function(resolve) {
                        CommonService.UpdateQiniuService(files, i, len, $scope.domain, vm.token, vm.folderId,(vm.article.articleId || vm.article.id),function (resp) {
                            if(resp.data.duplicate){
                                vm.duplicateList.push(resp.data)
                            }
                            vm.successNumber++;
                            if (vm.successNumber + vm.errorNumber >= files.length) {
                                vm.picLoading = false;
                                document.getElementById('uploadImg2').value = '';//上传完清空输入框
                                if (vm.errorNumber > 0) {
                                    vm.errorAlertPopup = true;
                                }
                            };
                            resolve(resp);
                        },function(errorFile,executionCompleted){
                            uploadFailedList.push(errorFile);
                            vm.errorNumber++;
                            if (vm.successNumber + vm.errorNumber >= files.length) {
                                $timeout(function(){
                                    vm.picLoading = false;
                                    vm.uploadFailedList = uploadFailedList;
                                    uploadFailedList = [];
                                    vm.errorAlertPopup = true;
                                    document.getElementById('uploadImg2').value = '';//上传完清空输入框
                                })
                            };
                            resolve();
                        },false)
                    });
                }

                $scope.errorAlertPopupClose = function(){
                    vm.errorAlertPopup = false;
                    vm.uploadFailedList = [];
                }

                $scope.duplicateChange = function (){
                    vm.isDuplicateList = false;
                    vm.duplicateList=[];
                    vm.maxId = null;
                    vm.minId = null;
                    vm.totalPhotoItems = null;
                    $scope.gallaryPic = [];
                    $scope.photos = [];
                    vm.indexNum = 0;
                    if(vm.folderId){
                        loadAll(vm.folderId);
                    } else {
                        loadAll('isNull');
                    }
                }

                $scope.errorPhotoView = function(){
                    $uibModal.open({
                        templateUrl: 'app/entities/page-compontents/uploadFailedImageListPopup.html',
                        controller: 'UploadFailedImageListPopupController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: [function() {
                                return vm.uploadFailedList;
                            }]
                        }
                    }).result.then(function (flag) {
                        if (flag) {
                            var files = vm.uploadFailedList;
                            for (var i = 0; i < files.length; i++) {
                                getBgImg(files, i);
                            }
                            vm.successNumber = 0;//上传成功数量
                            vm.errorNumber = 0;//上传失败数量
                            vm.picLoading = true;
                            vm.errorAlertPopup = false;
                            vm.uploadFailedList = [];
                        }else{
                            vm.errorAlertPopup = false;
                            vm.uploadFailedList = [];
                        }
                    });
                }

                function thumbnailatorPic(){
                    $uibModal.open({
                        templateUrl: 'app/entities/page-compontents/thumbnailator.html',
                        controller: 'ThumbnailatorController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: [function() {
                                return {
                                    files: bigSizePics,
                                    aid:(vm.article.articleId || vm.article.id),
                                    folderId:vm.folderId,
                                    domain:$scope.domain,
                                    token:vm.token,
                                    detectFaces:false
                                };
                            }]
                        }
                    }).result.then(function (values) {
                        bigSizePics=[];
                        vm.picLoading = false;
                        // if(values){
                        //     for (var j = 0; j < values.length; j++) {
                        //         var value = values[j];
                        //         value.bgImg = value.identifier;
                        //         $scope.photos.unshift(value);
                        //     }
                        //     vm.picLoading = false;
                        //     setTimeout(function () {
                        //         angular.forEach($scope.photos, function (item, z) {
                        //             item.index = z;
                        //         });
                        //     }, 400)
                        // }
                    }, function(){
                        vm.picLoading = false;
                    });
                }
                // websocket接收上传的图片（多端互通实时更新）
                function websocket(){
                    var urlws = vm.platformSetting.data.editorNotifyUrl.split("://")[1];
                    urlws = urlws.split("/")[0];
                    var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+(vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId));

                    ws.onOpen(function() {
                    });

                    ws.onMessage(function(message) {
                        var photo = JSON.parse(message.data);
                        if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                            vm.totalPhotoItems++;
                            vm.unusedQuantity++;//增加未使用数
                            var len = $scope.photos.length;
                            photo.identifier = $scope.domain + photo.identifier;
                            photo.select = false;
                            photo.index = len;
                            photo.usenum = 0;
                            photo.type = 'picture';
                            var _photo = null;
                            for (var i = 0; i < $scope.photos.length; i++) {
                                if ($scope.photos[i].id == photo.id) {
                                    _photo = $scope.photos[i];
                                    break;
                                }
                            }
                            if ((!photo.largeFlag && !_photo) || (photo.largeFlag && photo.largeStatus == 'done' && !_photo)) {
                                $scope.photos.unshift(photo);
                            }
                            if (_photo) {
                                _photo.largeStatus = photo.largeStatus;
                            }
                            if (vm.photoSort != 1 && vm.minId==null) {
                                vm.minId = photo.id;
                            }
                        }
                    });

                    ws.onError(function(error) {
                    });

                    ws.onClose(function() {
                    });
                }
            }]
    };

    angular.module('editorApp')
        .component('picture', PictureControl);

})();
